import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'

import EditUserLearningAssignmentForm from '../../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm'

import useRoutes from '../../state/useRoutes'

export default React.memo(function EditUserLearningAssignmentPage() {
  const { uuid, learningItemUuid } = useParams()

  const { close } = useOutletContext<any>()

  return <EditUserLearningAssignmentForm userUuid={uuid!} learningItemUuid={learningItemUuid!} onClose={close} />
})

export function EditUserLearningAssignmentPageBreadcrumb() {
  const { uuid, learningItemUuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return (
    <Link to={routes.editUserLearningAssignment.url({ uuid: uuid!, learningItemUuid: learningItemUuid! })}>
      {t('generic cta.edit')}
    </Link>
  )
}
